/**
 * Gymly affiliate outbound click tracking + HTTPS safety.
 * Does not include the full destination URL in analytics (hostname only).
 * Navigation works without JavaScript; validation is progressive enhancement.
 */
(function () {
  'use strict';

  var EVENT_NAME = 'affiliate_outbound_click';
  var TRACKING_KEYS = {
    utm_source: 1,
    utm_medium: 1,
    utm_campaign: 1,
    utm_content: 1,
    utm_term: 1,
    aff_id: 1,
    affiliate_id: 1,
    affiliateid: 1,
    partner_id: 1,
    partnerid: 1,
    click_id: 1,
    clickid: 1,
    irclickid: 1,
    ranmid: 1,
    raneid: 1,
    sharedid: 1,
    subid: 1,
    sub_id: 1,
    tracking_id: 1,
    trackingid: 1,
    awc: 1,
    epid: 1,
    epik: 1,
    ref: 1,
    referral: 1,
  };
  var BLOCKED = {
    javascript: 1,
    data: 1,
    file: 1,
    about: 1,
    intent: 1,
    gymly: 1,
    gymlyapp: 1,
  };

  function validateHttpsUrl(raw) {
    if (raw == null || String(raw).trim() === '') {
      return {ok: false, reason: 'empty'};
    }
    var trimmed = String(raw).trim();
    var parsed;
    try {
      parsed = new URL(trimmed);
    } catch (_e) {
      return {ok: false, reason: 'invalid'};
    }
    var scheme = parsed.protocol.replace(':', '').toLowerCase();
    if (BLOCKED[scheme]) return {ok: false, reason: 'blocked_scheme'};
    if (scheme !== 'https') return {ok: false, reason: 'insecure'};
    return {ok: true, url: parsed.toString(), hostname: parsed.hostname};
  }

  function hasTrackingParams(url) {
    try {
      var parsed = new URL(url);
      var keys = parsed.searchParams.keys();
      for (var next = keys.next(); !next.done; next = keys.next()) {
        if (TRACKING_KEYS[String(next.value).toLowerCase()]) return true;
      }
      return false;
    } catch (_e) {
      return false;
    }
  }

  function isConfigured(url, partnerMarkedTracked) {
    var validated = validateHttpsUrl(url);
    if (!validated.ok) return false;
    if (partnerMarkedTracked) return true;
    return hasTrackingParams(validated.url);
  }

  function buildPayload(link, hostname) {
    return {
      event: EVENT_NAME,
      gymly_product_id: link.dataset.productId || '',
      shopify_product_id: link.dataset.productId || '',
      shopify_variant_id: link.dataset.variantId || null,
      product_handle: link.dataset.productHandle || '',
      partner_brand: link.dataset.merchantName || '',
      destination_hostname: hostname || '',
      sales_source: 'gymly_web_shop',
      timestamp: new Date().toISOString(),
    };
  }

  function publishTracking(payload) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(EVENT_NAME, payload);
      }
    } catch (_error) {}

    try {
      if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(payload);
      }
    } catch (_error) {}

    try {
      document.dispatchEvent(
        new CustomEvent(EVENT_NAME, {
          detail: payload,
          bubbles: true,
        })
      );
    } catch (_error) {}
  }

  function disableLink(link) {
    link.removeAttribute('href');
    link.setAttribute('aria-disabled', 'true');
    link.classList.add('gymly-affiliate-cta__button--disabled');
    var root = link.closest('[data-gymly-affiliate-cta]');
    var unavailable = root && root.querySelector('[data-gymly-affiliate-unavailable]');
    if (unavailable) unavailable.removeAttribute('hidden');
  }

  function handleAffiliateClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var link = target.closest('[data-gymly-affiliate-link]');
    if (!(link instanceof HTMLAnchorElement)) return;

    var root = link.closest('[data-gymly-affiliate-cta]');
    var partnerMarked =
      (root && root.getAttribute('data-partner-marked-tracked') === 'true') ||
      link.getAttribute('data-affiliate-tracked') === 'true';

    var validated = validateHttpsUrl(link.getAttribute('href'));
    if (!validated.ok || !isConfigured(validated.url, partnerMarked)) {
      event.preventDefault();
      disableLink(link);
      return;
    }

    // Preserve exact validated URL (including tracking query params).
    link.setAttribute('href', validated.url);

    if (link.dataset.gymlyTracked === 'true') return;
    link.dataset.gymlyTracked = 'true';
    publishTracking(buildPayload(link, validated.hostname));

    window.setTimeout(function () {
      delete link.dataset.gymlyTracked;
    }, 1000);
  }

  function handleCopyDiscount(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var button = target.closest('[data-gymly-copy-discount]');
    if (!(button instanceof HTMLButtonElement)) return;

    var targetId = button.dataset.copyTarget;
    if (!targetId) return;

    var codeElement = document.getElementById(targetId);
    if (!codeElement) return;

    var code = (codeElement.textContent || '').trim();
    if (!code) return;

    var feedback = button.parentElement && button.parentElement.querySelector('.gymly-affiliate-meta__copy-feedback');

    if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
      navigator.clipboard.writeText(code).then(
        function () {
          if (feedback instanceof HTMLElement) {
            feedback.classList.remove('visually-hidden');
            window.setTimeout(function () {
              feedback.classList.add('visually-hidden');
            }, 2000);
          }
        },
        function () {}
      );
    }
  }

  // On load: disable non-HTTPS / untracked links without removing Gymly cart fallback.
  function hardenExistingLinks() {
    var links = document.querySelectorAll('[data-gymly-affiliate-link]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      if (!(link instanceof HTMLAnchorElement)) continue;
      var root = link.closest('[data-gymly-affiliate-cta]');
      var partnerMarked = root && root.getAttribute('data-partner-marked-tracked') === 'true';
      var validated = validateHttpsUrl(link.getAttribute('href'));
      if (!validated.ok || !isConfigured(validated.url, partnerMarked)) {
        disableLink(link);
      }
    }
  }

  document.addEventListener('click', handleAffiliateClick);
  document.addEventListener('click', handleCopyDiscount);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hardenExistingLinks);
  } else {
    hardenExistingLinks();
  }
})();
